module.exports = __webpack_public_path__ + "img/page_bg_peopleCount.7fad27fb.png";